import React from 'react';
import { ReactTableDefaults } from 'react-table';

// The admin website's lists (react-table): every column may shrink to 60px (react-table's default is 100px,
// so a list with many columns, e.g. clients with 11, was wider than a laptop screen and its delete button
// could not be reached). Columns share the width; long text is cut with "…" (titleCell shows it in full on
// hover); a list narrower than its columns scrolls sideways inside its card. Columns with buttons or a switch
// keep a fixed minimum width in their list, so the buttons are never cut.
Object.assign(ReactTableDefaults.column, { minWidth: 60 });

// A text cell whose full value shows on hover when it is cut short.
export function titleCell(row) {
	const value = row.value == null ? '' : row.value;
	return typeof value === 'string' || typeof value === 'number'
		? <span title={String(value)}>{value}</span>
		: value;
}
